module.exports = __webpack_public_path__ + "img/xinxikeji.5d80f0ab.png";